<mat-card >
    <div class="mat-card-header">
        <h2>Summer Internship</h2>
    </div>
    <mat-card-content>
        <div class="titles">
            <mat-card-title>JP Morgan Chase</mat-card-title>
            <mat-card-title>2021</mat-card-title>
        </div>
        <mat-card-subtitle>Summer Intern</mat-card-subtitle>

        <p>Investment Banking Technology</p>

    </mat-card-content>
</mat-card>
<mat-card >
    <div class="mat-card-header">
        <h2>Summer Internship</h2>
    </div>
    <mat-card-content>
        <div class="titles">
            <mat-card-title>Deutsche Bank AG</mat-card-title>
            <mat-card-title>2020</mat-card-title>
        </div>
        <mat-card-subtitle>Summer Intern</mat-card-subtitle>

        <p>During my summer internship, I learnt about the DB infrastructure & the different lines of business
            within the bank. Throughout this program, I worked within different teams to develop & present
            innovative solutions for different challenges faced by the bank. As a cohort, we were given
            introductory training in Corporate Finance, Investment Banking & technology.
            This experience has helped refine & acquire new technical & interpersonal skills</p>

    </mat-card-content>
</mat-card>

<mat-card >
    <div class="mat-card-header">
        <h2>Industrial Placement</h2>
    </div>
    <mat-card-content>
        <div class="titles">
            <mat-card-title>JP Morgan Chase</mat-card-title>
            <mat-card-title>2019-2020</mat-card-title>
        </div>
        <mat-card-subtitle>Software Engineering Intern</mat-card-subtitle>

        <p>I was selected for the software engineer industrial placement program at J.P. Morgan Chase. I 
            worked within Big Data/Data engineering. </p>

        <p>On a daily basis, I was responsible for:</p>
        <ul>
            
            <li>Data ingestion and quality checks</li>
            <li>Developing and maintaining the Big Data infrastructure</li>
            <li>Liaising with teams on a global scale to realise and achieve their targets for the project.</li>
            <li>Researching & developing Proof of concepts to integrate with the existing product.</li>
        </ul>
        <p>Throughout this placement, I’ve gained experience across multiple technologies, platforms & development
            methodologies. </p>
    </mat-card-content>
</mat-card>

<mat-card>
    <div class="mat-card-header">
        <h2>Spring Week</h2>
    </div>
    <mat-card-content>
        <div class="titles">
            <mat-card-title>Deutsche Bank AG</mat-card-title>
            <mat-card-title>2019</mat-card-title>
        </div>
        <mat-card-subtitle>Spring Into Banking Intern</mat-card-subtitle>
        <p>
            I spent a week shadowing members of staff and learning about the technology that underpins Fixed
            Income & Currencies, Credit Risk & Global Markets. I was able to gain a greater insight into how
            technology is leveraged at Deutsche to meet the needs of each line of business.
            At the end of the spring week, I was selected to return in 2020, as a Summer Technology Intern at
            the London offices of Deutsche bank
        </p>
    </mat-card-content>
</mat-card>
<mat-card>
    <div class="mat-card-header">
        <h2>Off-cycle Internship</h2>
    </div>
    <mat-card-content>
        <div class="titles">
            <mat-card-title>Mallappally Service Co-operative Bank, India</mat-card-title>
            <mat-card-title>2018</mat-card-title>
        </div>
        <mat-card-subtitle>Front Office Retail Banking Intern</mat-card-subtitle>

        <p>
            I spent two weeks as a work experience intern, in a front office role at a retail bank. I shadowed
            members of staff and learnt the different offers and products available to customers, impacts of
            emerging technology and current practises of the bank to name just a few.
            During these two weeks, I was able to extend my knowledge on the concepts of banking and finance
            which has greatly supplemented my current studies.
        </p>
    </mat-card-content>
</mat-card>
<mat-card>
    <div class="mat-card-header">
        <h2>Voluntary Work</h2>
    </div>
    <mat-card-content>
        <div class="titles">
            <mat-card-title>Rowans Hospice Charity</mat-card-title>
            <mat-card-title>2018</mat-card-title>
        </div>
        <mat-card-subtitle>Retail Volunteer</mat-card-subtitle>

        <p>
            I had the opportunity to spend my time as a retail volunteer at Rowans Hospice (A local charity that
            provides end of life and palliative care) during my holidays.
            This experience not only helped to serve and give back to my local community but also the chance to
            develop both professional and interpersonal skills, such as a greater level of communication, role
            flexibility, teamwork, conflict management and self-confidence.
        </p>
    </mat-card-content>
</mat-card>
